module.exports = __webpack_public_path__ + "img/acala.df00c34d.png";